// Shared sectors list — mirrors backend/sectors.py.
// Used by:
// - Admin client create/update forms
// - Admin clients table badge
// - Newsletter sector filter

export const SECTORS = [
  { key: "coiffure", label: "Coiffure", group: "Beauté & Bien-être" },
  { key: "beaute", label: "Beauté / Institut", group: "Beauté & Bien-être" },
  { key: "spa", label: "Spa", group: "Beauté & Bien-être" },
  { key: "salon_tatouage", label: "Salon de tatouage", group: "Beauté & Bien-être" },

  { key: "restaurant", label: "Restaurant", group: "Restauration" },
  { key: "pizzeria", label: "Pizzeria", group: "Restauration" },
  { key: "cafe", label: "Café", group: "Restauration" },
  { key: "boulangerie", label: "Boulangerie", group: "Restauration" },
  { key: "boucher", label: "Boucher", group: "Restauration" },
  { key: "hotel", label: "Hôtel", group: "Hébergement" },

  { key: "menuisier", label: "Menuisier / Menuiserie", group: "Artisanat" },
  { key: "serrurier", label: "Serrurier", group: "Artisanat" },
  { key: "plombier", label: "Plombier", group: "Artisanat" },
  { key: "electricien", label: "Électricien", group: "Artisanat" },
  { key: "peintre_batiment", label: "Peintre en bâtiment", group: "Artisanat" },
  { key: "macon", label: "Maçon", group: "Artisanat" },
  { key: "carreleur", label: "Carreleur", group: "Artisanat" },
  { key: "garagiste", label: "Garagiste", group: "Artisanat" },
  { key: "fleuriste", label: "Fleuriste", group: "Artisanat" },
  { key: "artisans_autre", label: "Artisan (autre)", group: "Artisanat" },

  { key: "art_artistes", label: "Art / Artistes", group: "Art & Culture" },

  { key: "medecin_prive", label: "Médecin privé", group: "Santé" },
  { key: "dentiste", label: "Dentiste", group: "Santé" },
  { key: "veterinaire", label: "Vétérinaire", group: "Santé" },
  { key: "psychologue", label: "Psychologue", group: "Santé" },

  { key: "osteopathe", label: "Ostéopathe", group: "Thérapies & Bien-être" },
  { key: "chiropracteur", label: "Chiropracteur", group: "Thérapies & Bien-être" },
  { key: "naturopathe", label: "Naturopathe", group: "Thérapies & Bien-être" },
  { key: "sophrologue", label: "Sophrologue", group: "Thérapies & Bien-être" },
  { key: "hypnotherapeute", label: "Hypnothérapeute", group: "Thérapies & Bien-être" },
  { key: "coach_vie", label: "Coach de vie", group: "Thérapies & Bien-être" },
  { key: "massotherapeute", label: "Massothérapeute", group: "Thérapies & Bien-être" },
  { key: "reflexologue", label: "Réflexologue", group: "Thérapies & Bien-être" },
  { key: "acupuncteur", label: "Acupuncteur", group: "Thérapies & Bien-être" },
  { key: "energeticien", label: "Énergéticien / Magnétiseur", group: "Thérapies & Bien-être" },
  { key: "studio_yoga", label: "Studio de yoga", group: "Thérapies & Bien-être" },
  { key: "studio_pilates", label: "Studio de pilates", group: "Thérapies & Bien-être" },

  { key: "avocat", label: "Avocat", group: "Services professionnels" },
];

export const SECTOR_MAP = Object.fromEntries(SECTORS.map((s) => [s.key, s]));

export function getSectorLabel(key) {
  return SECTOR_MAP[key]?.label || key || "—";
}

// Grouped options for <Select> components (optgroup style is not supported in shadcn Select,
// so we fallback to flat list but include the group as a prefix — users can also filter by group).
export function getGroupedSectors() {
  const groups = {};
  for (const s of SECTORS) {
    if (!groups[s.group]) groups[s.group] = [];
    groups[s.group].push(s);
  }
  return groups;
}
